import React from "react";
import ExternalLink from "./ExternalLink";

const SocialChannels = ({ lexicon, socialChannels }) => {
  if (!socialChannels || socialChannels.length === 0) return null;
  return (
    <section className="social-channels">
      {lexicon.socialTitle && (
        <h2 className="pt-10 text-lg font-semibold text-center text-white">
          {lexicon.socialTitle}
        </h2>
      )}
      <ul className="flex justify-center max-w-xs px-2 py-10 mx-auto mb-10 sm:max-w-22 sm:px-4">
        {socialChannels.map(
          ({
            name,
            url,
            image: {
              description,
              file: {
                fileLocal: { publicURL }, // no childImageSharp for SVGs. use this instead.
              },
            },
          }) => (
            <li key={name} className="mx-1 sm:mx-2">
              <ExternalLink
                href={url}
                title={name}
                showExternalIcon={false}
                target="_self"
                className="social-channel"
              >
                <img loading="lazy" src={publicURL} alt={description} />
                <span className="sr-only">{name}</span>
              </ExternalLink>
            </li>
          )
        )}
      </ul>
    </section>
  );
};

export default SocialChannels;
